export default "__VITE_ASSET__DZSk1YAd__"